import { MessageValidation } from "./message-validation";
import { IdValidation } from "./id.validation";
/**
 * Implementa a interface de validação, realizando a validação de requisições HTTP
 */
export class HttpValidation {
    constructor() {
        this.messageValidation = new MessageValidation();
        this.validations = [
            new IdValidation()
        ];
    }
    validate(request) {
        for (let validation of this.validations) {
            if (!validation.validate(request)) {
                this.messageValidation = validation.message;
                return false;
            }
        }
        return true;
    }
}
